import cn from "classnames";
import React, { useState } from "react";
import type { Answer, Question } from "../types";
import style from "./CorrectAnswers.module.scss";

export const CorrectAnswers = ({ questions }: { questions: Question[] }) => {
	const [currentQuestion, setCurrentQuestion] = useState(0);

	return (
		<div className={style.correctAnswers}>
			<p className={style.question}>{questions[currentQuestion]?.question}</p>
			<div className={style.answersContainer}>
				{questions[currentQuestion]?.answers?.map(
					(answer: Answer, index: number) => {
						return (
							<div key={answer.answer}>
								<p
									className={cn(style.answer, {
										[style.correct]: answer.correct,
									})}
								>
									{answer.answer}
								</p>
							</div>
						);
					},
				)}
			</div>

			<div className={style.dotsContainer}>
				{questions.map((question, index: number) => (
					<span
						key={question.question}
						className={`${style.dot} ${index === currentQuestion ? style.active : ""}`}
						onClick={() => setCurrentQuestion(index)}
						onKeyUp={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								setCurrentQuestion(index);
							}
						}}
					>
						●
					</span>
				))}
			</div>
		</div>
	);
};
